export default __webpack_public_path__ + "static/media/diamond-1.9acaccc0.png";